import React from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { Modal } from 'antd';
import { I18n as I } from 'react-redux-i18n';

import { LoaderOverlay, bind, isFunc, isNil } from 'vdlib';
import FinalStep from './BidSelectionSteps/FinalStep';

class BidSelectorWizard extends React.Component {
  constructor(props) {
    super(props);

    bind(this, ['advance', 'onHide', 'updateGarageData']);

    this.state = {
      step: 4,
      garageData: this.props.garage,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== true)
      return this.setState({ step: 1, garageData: null });

    if (
      this.state.step === 1 &&
      nextProps.garageId !== this.props.garageId &&
      !isNil(nextProps.garageId) &&
      nextProps.fetchingGarage !== true &&
      isFunc(this.props.fetchGarage)
    )
      return this.props.fetchGarage(nextProps.garageId);

    if (this.props.fetchingGarage === true && nextProps.fetchingGarage !== true)
      this.setState({ garageData: nextProps.garage });
  }

  populate(props) {
    if (isNil(props)) props = this.props;
  }

  onHide() {
    this.setState({
      step: 1,
      garageData: null,
    });
    this.props.onHide();
  }

  advance() {
    if (this.state.step === 3 && this.state.garageData == null) {
      this.setState({ requestSubmit: true });
      setTimeout(() => this.setState({ requestSubmit: false }));
      return;
    }

    let newStep =
      this.state.step === 2 && this.state.garageData != null
        ? 4
        : this.state.step + 1;
    this.setState({ step: newStep });
  }

  updateGarageData(garageData) {
    this.setState({ garageData });
  }

  render() {
    if (isNil(this.props.bid)) return false;

    // let canAdvance =
    //   this.state.step === 1 ||
    //   (this.state.step === 2 && this.state.garageData != null) ||
    //   this.state.step >= 3;

    return (
      <Modal
        visible={this.props.show}
        title={I.t('OFFER_SELECTION')}
        onOk={this.handleOk}
        onCancel={this.onHide}
        footer={[
          <button
            type="button"
            className={`btn btn-primary btn-sm float-right ml-sm ${
              this.props.loading ? 'disabled' : ''
            }`}
            disabled={this.props.loading}
            onClick={() =>
              this.props.onSubmit(this.props.bid.ID, this.state.garageData)
            }
          >
            {I.t('SAVE_INPUT')}
          </button>,
          /*{
                    this.state.step == 4 || (this.state.step == 1 && this.state.garageData != null)
                        ? <button type="button" className={ `btn btn-primary btn-sm float-right ml-sm ${this.props.loading ? 'disabled' : ''}` }
                            disabled={ this.props.loading } onClick={ () => this.props.onSubmit(this.props.bid.ID, this.state.garageData) }>Καταχώρηση</button>
                        : <button type="button" className={ `btn btn-primary btn-sm float-right ml-sm ${canAdvance ? '' : 'disabled'}` }
                            disabled={ !canAdvance } onClick={ this.advance }>Συνέχεια</button>
                }                    */
          <button
            type="button"
            className={`btn btn-default btn-sm float-right ${
              this.props.loading ? 'disabled' : ''
            }`}
            disabled={this.props.loading}
            onClick={this.onHide}
          >
            {I.t('CANCEL')}
          </button>,
        ]}
        // animation={true}
        // className="fade-scale"
        // show={this.props.show}
        // onHide={this.onHide}
        // dialogClassName={`custom-modal ${
        //   this.state.step === 3 ? 'fat-modal' : ''
        // }`}
        // style={{ top: this.state.step === 3 ? '7%' : '22%' }}
      >
        <div>
          <LoaderOverlay
            loading={
              this.props.loading === true || this.props.fetchingGarage === true
            }
          />
          <CSSTransitionGroup
            transitionName="page-transition"
            transitionAppear={true}
            transitionAppearTimeout={500}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
            component={'div'}
          >
            <FinalStep
              bid={this.props.bid}
              garageData={this.state.garageData}
              partDescription={this.props.partDescription}
            />
          </CSSTransitionGroup>
          <div className="clear" />
        </div>
      </Modal>
    );
  }
}

BidSelectorWizard.propTypes = {
  bid: PropTypes.object,
  garageId: PropTypes.number,
  loading: PropTypes.bool,
  partDescription: PropTypes.string,
  show: PropTypes.bool,

  onSubmit: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default BidSelectorWizard;
